import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-sm" }

import { computed } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/solid'


export default /*@__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    label: {},
    isCloseable: { type: Boolean },
    isClickable: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {





const classes = computed(() => {
  let classes = ["flex", "items-center", "gap-x-1.5", "text-center", "justify-center", "rounded-md", "bg-blue-100", "py-0.5", "font-medium", "text-blue-700"];

  if (__props.isClickable) {
    classes = [...classes, "hover:cursor-pointer", "hover:bg-blue-700", "hover:text-white"];
  }

  if (__props.isCloseable) {
    classes = [...classes, "pl-2", "pr-1"];
  } else {
    classes = [...classes, "px-2"];
  }

  return classes;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(classes.value)
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1),
    (_ctx.isCloseable)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "p-0.5 hover:bg-blue-200 hover:cursor-pointer rounded"
        }, [
          _createVNode(_unref(XMarkIcon), { class: "size-4" })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})